import type { Airport } from "@airhelp/react";
import type { LanguageCode } from "config/languages";
import { getPageUrl } from "utils/getPageUrl";

export const getFunnelUrl = (
  departureAirport: Airport,
  arrivalAirport: Airport,
  language: LanguageCode,
  funnelAbParameter = ""
) => {
  const departureAirportValue = departureAirport ? departureAirport.iata : "";
  const arrivalAirportValue = arrivalAirport ? arrivalAirport.iata : "";

  return `${getPageUrl(
    language,
    "webappNewClaim"
  )}&departureAirportIata=${departureAirportValue}&arrivalAirportIata=${arrivalAirportValue}${funnelAbParameter}`;
};
